<template>
  <a-modal
    :visible="visible"
    @cancel="close"
    class="container-grid-convert-modal"
    title="画面选择"
    :okButtonProps="{
      props: {
        disabled: !activeItem
      }
    }"
    @ok="handleOK"
  >
    <button
      type="button"
      v-for="item in containerGridIcons"
      :key="item.name"
      class="container-grid-convert-modal__item"
      :class="{
        'container-grid-convert-modal__item--active': activeItem === item.name
      }"
      @click="handleSelect(item)"
    >
      <shape-renderer
        :params="{
          shape: 'path',
          width: 60,
          height: 40,
          strokeWidth: 0,
          color: 'var(--color)',
          d: item.d,
          shapeX: 0,
          shapeY: 0,
          shapeScale: 1
        }"
        class="shape-icon__shape"
      />
    </button>
  </a-modal>
</template>
<script>
import { containerGridIcons } from '../../utils/shapes';
import ShapeRenderer from '../player/ShapeRenderer';

export default {
  props: ['visible'],
  components: { ShapeRenderer },
  data() {
    return {
      activeItem: null,
      containerGridIcons
    };
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    handleSelect(item) {
      this.activeItem = item.name;
    },
    handleOK() {
      this.$emit('ok', this.activeItem);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.activeItem = null;
      }
    }
  }
}
</script>
<style scoped>
.container-grid-convert-modal .ant-modal-body {
  display: flex;
}

.container-grid-convert-modal__item {
  width: calc(25% - 14px);
  height: 60px;
  position: relative;
  margin-right: 14px;
  margin-bottom: 11px;
  --color: #dcdcdc;
  cursor: default;
  outline: 0;
  border: 2px solid transparent;
  border-radius: 0;
  background: #fff;
  padding: 0;
  transition: 0.3s;
}

.container-grid-convert-modal__item:hover,
.container-grid-convert-modal__item:focus {
  --color: #40a9ff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
}

.container-grid-convert-modal__item--active {
  --color: #1890ff;
  border-color: #1890ff;
}

.shape-icon__shape {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>